'use strict';

/**
 * Communication service for reading application version.
 */
(function($) {
  window.atex = window.atex || {};

  atex.VersionServiceHandler = function(q) {
    return {
      getVersion: function() {
        var deferred = q.defer();

        $.ajax('version', {
          dataType: 'json',

          success: function(data, textStatus, jqXHR) {
            deferred.resolve(data.version);
          },

          error: function(jqXHR, textStatus, errorThrown) {
            var e = atex.onecms.HTTPUtils.createError(jqXHR, 'atex.VersionServiceHandler', {
              'default': 'Error while reading version information from server!'
            });

            deferred.reject(e);
          }
        });

        return deferred.promise;
      }
    };
  };
})(jQuery);
